import { forwardRef } from "react";
import { Command as CommandPrimitive } from "cmdk";

import type {
  TComboboxCommandElement,
  TComboboxCommandProps,
} from "@/ui/components/form/Combobox/Combobox.config";
import { cn } from "@/ui/lib/utils";

export const ComboboxCommand = forwardRef<TComboboxCommandElement, TComboboxCommandProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <CommandPrimitive
      data-component="ComboboxCommand"
      ref={ref}
      className={cn(
        "flex h-full w-full flex-col overflow-hidden bg-component-input-focused text-foreground-default",
        className,
      )}
      {...props}
    />
  ),
);

ComboboxCommand.displayName = CommandPrimitive.displayName;
